export interface ProductData {
  general: Record<string, any>;
  attributes: any[];
  featuredInfos: any[];
  images: MediaImage[];
}

export const mergeGeneral = (
  original: Record<string, any>,
  revision: Record<string, any>
) => {
  return {
    ...original,
    ...revision,
  };
};

export const mergeAttributes = (
  originalAttributes: any[],
  revisionAttributes: any[]
) => {
  // Orijinal attribute'ları kopyala
  const mergedAttributes = JSON.parse(JSON.stringify(originalAttributes));

  // Revizyon verilerindeki her attribute için
  revisionAttributes.forEach((revisionAttr) => {
    // Orijinal verilerde aynı ID'ye sahip attribute'u bul
    const originalAttrIndex = mergedAttributes.findIndex(
      (attr: any) => attr.attribute_id === revisionAttr.attribute_id
    );

    if (originalAttrIndex !== -1 && revisionAttr.selected_term) {
      // Sadece selected_term değerini güncelle
      mergedAttributes[originalAttrIndex].selected_term = revisionAttr.selected_term;
    }
  });

  return mergedAttributes;
};

export const mergeFeaturedInfos = (
  originalInfos: any[],
  revisionInfos: any[]
) => {
  return [...revisionInfos, ...originalInfos];
};

export const mergeCurrentData = (
  isRevisionView: boolean,
  originalData: ProductData,
  revisionData: ProductData & { revision_id: number | null }
): ProductData => {
  if (!isRevisionView) {
    return JSON.parse(JSON.stringify(originalData));
  }

  return {
    general: mergeGeneral(originalData.general, revisionData.general),
    images: [...revisionData.images],
    attributes: mergeAttributes(
      originalData.attributes,
      revisionData.attributes
    ),
    featuredInfos: mergeFeaturedInfos(
      originalData.featuredInfos || [],
      revisionData.featuredInfos || []
    ),
  };
};
